class AnimatedAccordion extends HTMLElement{
  constructor( ) {
    super();
    this.details = this.querySelector('details');

    this.summary = this.details.querySelector('summary');
    this.content = this.details.querySelector('.accordion__content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    
    this.summary.addEventListener('click', (event) => this.onClick(event) );
  }

  onClick(event) {
    event.preventDefault();
    this.details.style.overflow = 'hidden';
    
    if (this.isClosing || !this.details.open) this.open();
    else if (this.isExpanding || this.details.open) this.shrink();
  }

  shrink() {
    this.isClosing = true;
    
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel();
    
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] }, 
      { duration: 200, easing: 'ease-out'}
    );
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel();
    
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] }, 
      { duration: 200, easing: 'ease-out' }
    );
    
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(isOpen) {
    this.details.open = isOpen;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = '';
  }
}
customElements.define('nbn-accordion', AnimatedAccordion);

class ExpressCheckout extends HTMLElement{
  cartUpdateUnsubscriber = undefined;
  
  constructor( ) {
    super();
    
    // this.updateCheckoutTotal();

    this.addEventListener("click", (event) => { 
      event.preventDefault(); 
      window.location = '/checkout'; 
    });
  }
  
  connectedCallback(){
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.updateCheckoutTotal.bind(this));
  }
  disconnectedCallback() { if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber(); }

  updateCheckoutTotal(){
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count === 0){
          this.makeVisible(false);
          return;
        }
        this.makeVisible(true);
        // let checkoutTotal = this.querySelector('.checkout-total');
        // let totalPrice = cart.total_price / 100;
        // checkoutTotal.textContent = `${totalPrice.toFixed(2)} ${cart.currency}`;  
      }
     )
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  makeVisible(visible){
    if(visible){
      if( this.classList.contains("retracted") ) this.classList.remove("retracted");
    }
    else{
      if( !this.classList.contains("retracted") ) this.classList.add("retracted");
    }
  }
  
}
customElements.define('nbn-express-checkout', ExpressCheckout);